import { ContentData } from "../../src/apis/stateful-content";
import { ColumnTypes } from "../../src/components/stateful-content/stateful-table/column-types";
const fs = require("fs");
const output = `${__dirname}/../../resources/generated-mock-data/`;
import type { StatusType } from "@trumpf/ux.ui-widgets/dist/types";

enum AssignmentTypes {
    Service = "service",
    Maintenance = "maintenance",
    ServiceMaintenance = "service_maintenance",
}

const completed: StatusType = "MISSION_COMPLETED";
const created: StatusType = "MISSION_CREATED";
const planned: StatusType = "MISSION_PLANNED";
const confirmed: StatusType = "MISSION_CONFIRMED";
// const proposed: StatusType = "MISSION_PROPOSED";
// const technicianScheduled: StatusType = "MISSION_TECHNICIAN_SCHEDULED";

const response: ContentData = {
    totalCount: 62,
    filteredCount: 62,
    labelCount: "Treffer",
    schema: {
        assignmentType: {
            type: ColumnTypes.Text,
            sortable: true,
            "primary-mobile": false,
        },
        status: {
            type: ColumnTypes.Status,
            sortable: true,
            "primary-mobile": false,
        },
        date: {
            type: ColumnTypes.Date,
            sortable: true,
            "primary-mobile": true,
        },
        equipmentName: {
            type: ColumnTypes.Text,
            sortable: true,
            className: "equipment-name",
            "primary-mobile": false,
        },
        missionNumber: {
            type: ColumnTypes.Text,
            sortable: true,
            "primary-mobile": true,
        },
        sisCaseId: {
            type: ColumnTypes.Text,
            sortable: true,
            "primary-mobile": false,
        },
        detailUrl: {
            type: ColumnTypes.DetailLink,
            sortable: false,
            "primary-mobile": false,
        },
    },
    items: [
        {
            equipmentName: "TruMatic 7000 Großformat",
            equipmentNumber: "WDEDEMO009",
            missionNumber: "836484330",
            sisCaseId: "8466123",
            assignmentType: AssignmentTypes.Maintenance,
            date: "2020-05-20 17:32:33",
            detailUrl: "https://trumpf.com/mission/12345",
            status: completed,
        },
        {
            equipmentName: "TruMatic 7100 Großformat",
            equipmentNumber: "WDEDEMO010",
            missionNumber: "836484331",
            sisCaseId: "8466124",
            assignmentType: AssignmentTypes.Service,
            date: "2020-05-21 18:33:34",
            detailUrl: "https://trumpf.com/mission/12346",
            status: created,
        },
        {
            equipmentName: "TruMatic 7100 Großformat",
            equipmentNumber: "WDEDEMO010",
            missionNumber: "836484361",
            sisCaseId: "8466127",
            assignmentType: AssignmentTypes.ServiceMaintenance,
            date: "2020-05-22 21:01:34",
            detailUrl: "https://trumpf.com/mission/12346",
            status: confirmed,
        },
        {
            equipmentName: "TruMatic 7100 Großformat",
            equipmentNumber: "WDEDEMO013",
            missionNumber: "836484337",
            sisCaseId: "8466126",
            assignmentType: AssignmentTypes.ServiceMaintenance,
            date: "2020-05-31 18:33:34",
            detailUrl: "https://trumpf.com/mission/12346",
            status: planned,
        },
        {
            equipmentName: "TruMatic 7100 Großformat",
            equipmentNumber: "WDEDEMO010",
            missionNumber: "836484333",
            sisCaseId: "8466125",
            assignmentType: AssignmentTypes.Maintenance,
            date: "2020-05-22 18:33:34",
            detailUrl: "https://trumpf.com/mission/12346",
            status: confirmed,
        },
    ],
};

const emptyResponse: ContentData = {
    totalCount: 0,
    filteredCount: 0,
    labelCount: "Treffer",
    items: [],
    error: {
        head: "Zur Zeit sind keine Einsätze vorhanden.",
        copy: "",
    },
};

const filteredEmptyResponse: ContentData = {
    ...response,
    filteredCount: 0,
    items: [],
    error: {
        head: "Für die Ausgewählten Filter gibt es keine Treffer.",
        copy: "Bitte ändern Sie Ihre Filtereinstellung, um fortzufahren.",
    },
};

const writeToFile = (object: ContentData, name: string) => {
    console.log(JSON.stringify(object));
    fs.writeFileSync(`${output}${name}.json`, JSON.stringify(object));
};

const response1 = {
    ...response,
    nextPage: `generated-mock-data/mymissions-page2.json`,
};

const response2 = {
    ...response,
    nextPage: `generated-mock-data/mymissions-page3.json`,
    items: response.items.map((item) => ({
        ...item,
        equipmentName: item.equipmentName + " 2",
    })),
};

const response3 = {
    ...response,
    nextPage: null,
    items: response.items.map((item) => ({
        ...item,
        equipmentName: item.equipmentName + " 3",
    })),
};

writeToFile(response1, "mymissions");
writeToFile(response2, "mymissions-page2");
writeToFile(response3, "mymissions-page3");
writeToFile(emptyResponse, "mymissions-empty");
writeToFile(filteredEmptyResponse, "mymissions-filtered-empty");
